import type { InvestmentValueFormInput } from "web_myplann/Portfolio/Components/Redesign/Detail/Value/investmentValueFormSchema";

export const INVESTMENT_VALUE_FORM_DEFAULT_VALUES: Partial<InvestmentValueFormInput> =
	{
		invested: null,
		date: null,
	};

export const getInvestmentValueFormDefaults = (
	invested: number | null,
): Partial<InvestmentValueFormInput> => ({
	...INVESTMENT_VALUE_FORM_DEFAULT_VALUES,
	invested: invested === null ? null : Math.round(invested),
	date: new Date(),
});
